function mapGetOneCustomerListData(responseData) {
    return {
        ...responseData,
    };
}

function mapGetListCustomerListsData(responseData) {
    return responseData.map((data) => ({
        ...data,
    }));
}

export { mapGetOneCustomerListData, mapGetListCustomerListsData };
